/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Spec_Can_RequireInputs */

const en_endpoint_spec_can_require = /** @type {(inputs: Endpoint_Spec_Can_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`can require`)
};

const zh_hans1_endpoint_spec_can_require = /** @type {(inputs: Endpoint_Spec_Can_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可设为必填`)
};

const pt_br2_endpoint_spec_can_require = /** @type {(inputs: Endpoint_Spec_Can_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pode ser exigido`)
};

const es_endpoint_spec_can_require = /** @type {(inputs: Endpoint_Spec_Can_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`se puede exigir`)
};

const fr_endpoint_spec_can_require = /** @type {(inputs: Endpoint_Spec_Can_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`peut exiger`)
};

const de_endpoint_spec_can_require = /** @type {(inputs: Endpoint_Spec_Can_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kann erfordern`)
};

const ru_endpoint_spec_can_require = /** @type {(inputs: Endpoint_Spec_Can_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`может потребовать`)
};

const it_endpoint_spec_can_require = /** @type {(inputs: Endpoint_Spec_Can_RequireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`può richiedere`)
};

/**
* | output |
* | --- |
* | "can require" |
*
* @param {Endpoint_Spec_Can_RequireInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_spec_can_require = /** @type {((inputs?: Endpoint_Spec_Can_RequireInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Spec_Can_RequireInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_spec_can_require(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_spec_can_require(inputs)
	if (locale === "es") return es_endpoint_spec_can_require(inputs)
	if (locale === "fr") return fr_endpoint_spec_can_require(inputs)
	if (locale === "de") return de_endpoint_spec_can_require(inputs)
	if (locale === "ru") return ru_endpoint_spec_can_require(inputs)
	if (locale === "it") return it_endpoint_spec_can_require(inputs)
	return en_endpoint_spec_can_require(inputs)
});